<template>
      <div no-body class="lookup"> 
          <b-row>
            <b-col lg="8">
                <b-input-group>
                  <b-input-group-prepend><span class="pt-2 mr-3">Filter</span></b-input-group-prepend>
                  <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                  </b-input-group-append>
                </b-input-group>
            </b-col>
          </b-row>
                <b-table
                  class="mb-0"
                  ref="tblPlatform"
                  responsive style="font-size:smaller;" 
                  striped hover
                  :items="atagrp.items"
                  :fields="atagrp.fields"
                  :current-page="atagrp.page"
                  :per-page="20"
                  :sort-by.sync="atagrp.sortBy"
                  :sort-desc.sync="atagrp.sortDesc"
                  :key="atagrp.limit" 
                  :filter="filter"
                >
                <template v-slot:cell(selected)="data">
                    <input
                    name="selectcatg"
                    type="checkbox"
                    @change="checkedGrp($event,data.item)"
                    :data-key="data.item.busiCatgNm"
                    :checked="ischeckedGrp(data.item.busiCatgNm)"
                  />
                </template>

                <template v-slot:cell(nomor)="data">
                  {{ ((atagrp.page-1)*atagrp.limit)+data.index +1}}
                </template>

                </b-table>
              <b-row v-if="(atagrp.total>20)">
                  <b-col lg="6">
                    <div class="ml-2">
                        Showing
                        {{(atagrp.page - 1) * atagrp.limit + 1}}
                        to
                        {{atagrp.page * atagrp.limit}}
                        of
                        {{atagrp.total}}
                        entries
                    </div>    
                  </b-col>
                  <b-col lg="6">
                    <b-pagination
                      align="right"
                      :total-rows="atagrp.total"
                      :per-page="20"
                      v-model="atagrp.page"
                    ></b-pagination>
                  </b-col>
                </b-row>
          <b-row>
            <b-col lg="10">
                <b-input-group>
                  <b-button class="btn btn-success ml-2 mr-1" @click="selectAtagrp" > <i class="fa fa-check-square"></i> Select</b-button>
                  <b-input-group-append><span class="pt-2 mr-3">{{selectedGrp.length}} Platform(s) </span></b-input-group-append>
                </b-input-group>
            </b-col>
          </b-row>

      </div>
</template>
<style lang="scss">
  .lookup {
    td {
      padding: 0;
      a {
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import crud from "../../apis/crud";
import toastr from "mini-toastr";
toastr.init();

export default {
  data() {
    return {
      tabIndex:0,
      selectedGrp:[], 
      atagrp: {
        items:[],
          tablename: "vendor-business-catg",
          page: 1,
          limit: 10000,
          total: 0,
          sortBy: "busiCatgNm",
          sortDesc: false,
          fields: [
          {
            key: "selected",
            label: "",
            thStyle: "width:20px",
            thClass:"text-center",
            tdClass:"text-center",
          },
          {
            key: "busiCatgNm",
            label: "Business Category/Group",
          },
        ],
      },
      filter:null,
    };
  },
  props: ["model"],
  created: async function() {
      this.data();
  },
  methods: {
    data: async function(ctx) {
      this.atagrp.limit=10000;
      this.atagrp.sortDir = this.atagrp.sortDesc ? "desc" : "asc";

      this.lkuLoading=true;
      const catgs = await  crud.list(this.atagrp);
      this.lkuLoading=false;
      this.atagrp.items=catgs;
      console.log('this.atagrp.items: ',this.atagrp.items);
      console.log('this.model: ',this.model)
      if (this.model) {
        const arrGrp = this.model.split(',');
        for (let index = 0; index < arrGrp.length; index++) {
          const val = arrGrp[index];
          const ada = this.atagrp.items.find(x => x.busiCatgNm === val);
          if (ada) {
            this.selectedGrp.push(val);
          }
        } 
      }

      this.atagrp.limit= 20;
    },

    selectAtagrp() {
        this.$emit("click", this.selectedGrp.sort());
    },  
    refresh() {
      this.$refs.tblPlatform.refresh();
    },
    ischeckedGrp(val){
      const ada = this.selectedGrp.find(x => x === val);
      if(ada){
        return 'checked'
      }else{
        return '';
      }
    },
    checkedGrp(item,record) {      
      const busiCatgNm = item.target.attributes["data-key"].value;
      if (item.target.checked) {
        const ada = this.selectedGrp.find(x => x === busiCatgNm);
        if (!(ada)){
          this.selectedGrp.push(busiCatgNm);
        }
      } else {
        const findIdx = this.selectedGrp.findIndex(x => x === busiCatgNm);
        this.selectedGrp.splice(findIdx, 1);
      }
    },

  }
};
</script>
